// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"13a23a85","239":"3b65c28a","455":"33038ce9"}[chunkId] + ".chunk.js";
};